import styled from 'styled-components';
export const MapAndInformationContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 10px 150px 0 150px;
  @media (max-width: 1250px) { margin: 10px 100px 0 100px; }
  ${props => props.theme.mixins.mobile(`
    flex-direction: column; 
    align-items: flex-start; 
    margin: 10px 0 0 0
  `)}
`;
export const MapWrapper = styled.div `
  width: 555px;
  height: auto;
  background-color: #dfdfdf;
  margin-right: 140px;
  @media (max-width: 1250px) { margin-right: 100px; width: 500px; }
  @media (max-width: 1100px) { margin-right: 50px; }
  @media (max-width: 1000px) { width: 400px; }
  ${props => props.theme.mixins.mobile(`
    align-self: center;
    width: 100vw; 
    margin: 0 0 25px 0;
  `)}
  @media (max-width: 450px) { height: 180px; }
`;
